function navbar(theme, ownerState) {
  const { palette, boxShadows, functions, transitions, breakpoints, borders } = theme;
  const { transparentNavbar, absolute, light, darkMode } = ownerState;

  const { dark, white, text, transparent, background } = palette;
  const { navbarBoxShadow } = boxShadows;
  const { rgba, pxToRem } = functions;
  const { borderRadius } = borders;

  return {
    boxShadow: transparentNavbar || absolute ? 'none' : navbarBoxShadow,
    backdropFilter: transparentNavbar || absolute ? 'none' : `saturate(180%) blur(${pxToRem(18)})`,
    backgroundColor:
      transparentNavbar || absolute
        ? `${transparent.main} !important`
        : rgba(darkMode ? background.default : white.main, 0.86),

    color: () => {
      if (light) return white.main;
      if (transparentNavbar) return text.main;
      return dark.main;
    },

    top: absolute ? 0 : pxToRem(10),
    minHeight: pxToRem(56), // ✅ daha kısa
    display: 'grid',
    alignItems: 'center',
    borderRadius: borderRadius.xl,

    paddingTop: pxToRem(6),
    paddingBottom: pxToRem(6),
    paddingRight: absolute ? pxToRem(8) : 0,
    paddingLeft: absolute ? pxToRem(10) : 0,

    '& > *': {
      transition: transitions.create('all', {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.shorter,
      }),
    },

    '& .MuiToolbar-root': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',

      [breakpoints.up('sm')]: {
        minHeight: 'auto',
        padding: `${pxToRem(2)} ${pxToRem(12)}`,
      },
    },
  };
}

const navbarContainer = ({ breakpoints }) => ({
  flexDirection: 'column', // ✅ tek satır
  alignItems: 'center',
  justifyContent: 'space-between',
  pt: 0,
  pb: 0,
  width: '100%',

  [breakpoints.up('md')]: {
    flexDirection: 'row', // ✅ desktop: tek satır    alignItems: "center",
    paddingTop: '0',
    paddingBottom: '0',
  },
});

const navbarLeft = ({ breakpoints }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  minWidth: 0,
  flex: '0 0 auto',

  [breakpoints.up('md')]: {
    gap: 12,
  },
});

const navbarRight = ({ breakpoints }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  minWidth: 0,
  flex: '1 1 auto',
  justifyContent: 'flex-end',

  [breakpoints.up('md')]: {
    gap: 12,
  },
});

const navbarIconButton = ({ typography: { size } }) => ({
  px: 0.75,
  '& .material-icons, .material-icons-round': {
    fontSize: `${size.xl} !important`,
  },
});

const mobileHamburger = () => ({
  padding: 6, // ✅ default 8-12 yerine
  marginRight: 2,
});

const smartSearchSx = ({ breakpoints }) => ({
  minWidth: 0,
  width: '100%',
  maxWidth: 740,

  [breakpoints.down('md')]: {
    maxWidth: 'none', // ✅ mobilde sıkıştırma yapmasın
  },

  '& .MuiInputBase-root': {
    borderRadius: '14px',
  },
});

export {
  navbar,
  navbarContainer,
  navbarLeft,
  navbarRight,
  navbarIconButton,
  mobileHamburger,
  smartSearchSx,
};
